import React from 'react';
import {
  Bar, BarChart, CartesianGrid, Legend, Tooltip, XAxis, YAxis,
} from 'recharts';
import PropTypes from 'prop-types';
import { dMargin, valueFormatter } from './consts';

function BarPlot({ data, size }) {
  return (
    <BarChart data={data.items} width={size.width} height={size.height} margin={dMargin}>
      <CartesianGrid strokeDasharray="4 1 1 1 " />
      <XAxis dataKey={data.dataKey.key} la_bel={data.dataKey.label} />
      <YAxis tickFormatter={valueFormatter} width={100} />
      <Tooltip formatter={valueFormatter} />
      <Legend
        payload={data.lines.map((line) => ({
          value: line.label,
          id: line.name,
          type: 'square',
          color: line.color,
        }))}
      />
      {data.lines.map((line) => (
        <Bar key={line.name} dataKey={line.name} fill={line.color} name={line.label} />
      ))}
    </BarChart>
  );
}

BarPlot.propTypes = {
  data: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({})),
    dataKey: PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
    }),
    lines: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      name: PropTypes.string,
      color: PropTypes.string,
    })),
  }).isRequired,
  size: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }).isRequired,
};

export default BarPlot;
